import { Pipe, PipeTransform } from '@angular/core';
import { RoleEnum } from '@libs/core/api';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'role',
})
export class RolePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(
    role?: RoleEnum | null,
    short = true,
    superOperatore?: boolean | null,
    buyer?: boolean | null,
    superBuyer?: boolean | null
  ): string {
    if (!role) {
      return '';
    }

    if (role === RoleEnum.Buyer && superBuyer) {
      return this.translateService.instant(
        `roles.SUPERBUYER.${short ? 'short' : 'long'}`
      );
    }

    if (role === RoleEnum.Buyer) {
      return this.translateService.instant(
        `roles.BUYER.${short ? 'short' : 'long'}`
      );
    }

    const roleKey =
      role === RoleEnum.Operatore && superOperatore ? 'SUPEROPERATORE' : role;

    if (buyer || superBuyer) {
      const baseRole = this.translateService.instant(
        `roles.${roleKey}.${short ? 'short' : 'long'}`
      );

      const buyerType = superBuyer
        ? this.translateService.instant(
            `roles.SUPERBUYER.${short ? 'short' : 'long'}`
          )
        : this.translateService.instant(
            `roles.BUYER.${short ? 'short' : 'long'}`
          );

      return this.translateService.instant('roles.COMBINED_ROLE', {
        role: baseRole,
        buyerType: buyerType,
      });
    }

    return this.translateService.instant(
      `roles.${roleKey}.${short ? 'short' : 'long'}`
    );
  }
}
